// extracted by mini-css-extract-plugin
export default {"title":"_6e00346f7d","inner_title":"_22cfbc97a7","charge_btn":"fd5f5889ef"};